import { useTranslation } from 'react-i18next';
import { Icon, Typography } from '../../atoms';
import { styled } from '@mui/material/styles';

type Props = {
    title: string;
    infoText?: string;
};

const Container = styled('div')(() => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBlock: '4rem',
    flex: 1
}));

const IconContainer = styled('div')<{ size: number }>(({ theme, size }) => ({
    borderRadius: '100px',
    background: theme.palette.primary[50],
    height: `${size}px`,
    width: `${size}px`,
    display: 'flex',
    alignItems: 'center',
    padding: size === 100 ? '21px 18px 25px 28px' : '2rem 3.2rem 3rem 2rem',
    justifyContent: 'flex-end',
    '& > svg': {
        color: theme.palette.primary[500],
        scale: size === 100 ? '1' : '2.5',
        '--background-color': theme.palette.primary[50]
    }
}));
export const NoGoal = ({ title, infoText }: Props) => {
    const { t } = useTranslation();
    return (
        <Container>
            <IconContainer size={title === t('NO_GOALS') ? 183 : 100}>
                <Icon id="target_rounded_md" size={54} />
            </IconContainer>
            <Typography mb="7px" mt="24px" color="neutral.black" variant="headers.h3">
                {title}
            </Typography>
            {infoText && (
                <Typography
                    color="neutral.grey.400"
                    variant="body.large"
                    sx={{ maxWidth: '100%', textAlign: 'left', whiteSpace: 'nowrap' }}
                >
                    {infoText}
                </Typography>
            )}
        </Container>
    );
};
